// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bXUKU2WcKV0nJX {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: var(--ds-text-subtle, #44546f);
  line-height: 12px;
  cursor: pointer;
}
.bXUKU2WcKV0nJX .q_35VqKFxcT8gC {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-right: 4px;
}
.bXUKU2WcKV0nJX .jMmX1ch3aYWHby {
  font-size: 12px;
}
`, ""]);
// Exports
export var privacyLabel = `bXUKU2WcKV0nJX`;
export var icon = `q_35VqKFxcT8gC`;
export var labelText = `jMmX1ch3aYWHby`;
export default ___CSS_LOADER_EXPORT___;
